import "./header.css";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { authGuest, setDelToken, setToken, isLogin, getUser, isDeveloper } from "../service/authService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useCallback, useEffect, useState } from "react";
import HeaderTimer from "./headerTimer";
import HeaderFullScr from "./headerFullscr";
import { Reply } from "@material-ui/icons";
import kendo from "@progress/kendo-ui";

function Header({ conn, setUpdateLoginStatus }) {
  const [currentHist, setCurrentHist] = useState("");
  const userInfo = getUser();
  const history = useHistory();
  const location = useLocation();
  // 로그인
  const loginClickEvt = () => {
    history.push("/login");
  };

  // 로그아웃
  const logoutClickEvt = () => {
    kendo.confirm("로그아웃 하시겠습니까?").then(() => {
      setDelToken();
      authGuest(conn).then(result => {
        setToken(result.token);
        setUpdateLoginStatus(false);
        history.push("/");
      });
    });
  };

  const menuChangeEvt = e => {
    const { value } = e;
    const current = menuList.find(m => m.menuUrl === value.menuUrl);
    setCurrentHist(current);
    history.push(value.menuUrl);
  };

  const [menuList, setMenuList] = useState([
    { menuTerm: "대시보드", menuUrl: "/dashboard"},
    // { menuTerm: "대시보드", menuUrl: "/monitor/dashboard" },
    { menuTerm: "전체현황", menuUrl: "/monitor/status/all" },
    // { menuTerm: "설치현황", menuUrl: "/monitor/status/install" },
    { menuTerm: "대상자정보", menuUrl: "/log/elder" },
    { menuTerm: "알림이력", menuUrl: "/log/alert" },
    { menuTerm: "담당자관리", menuUrl: "/mngt/manager" },
    { menuTerm: "대상자관리", menuUrl: "/mngt/elder" },
    { menuTerm: "계정설정", menuUrl: "/mngt/account" },
    { menuTerm: "장비관리", menuUrl: "/mngt/device" },
  ]);

  const headerTextClickEvt = () => {
    window.location.href = "/monitor/status/all";
    // window.location.href = "/dashboard";
  };

  useEffect(() => {
    const current = menuList.find(m => m.menuUrl === location.pathname);
    setCurrentHist(current);

    const _menuList = userInfo
      ? userInfo.userTypeCode === 2005 || userInfo.userId === "ar"
        ? [
            // { menuTerm: "대시보드", menuUrl: "/dashboard"},
            // { menuTerm: "대시보드", menuUrl: "/monitor/dashboard" },
            { menuTerm: "전체현황", menuUrl: "/monitor/status/all" },
            // { menuTerm: "설치현황", menuUrl: "/monitor/status/install" },
            { menuTerm: "대상자정보", menuUrl: "/log/elder" },
            { menuTerm: "알림이력", menuUrl: "/log/alert" },
            { menuTerm: "담당자관리", menuUrl: "/mngt/manager" },
            { menuTerm: "대상자관리", menuUrl: "/mngt/elder" },
            { menuTerm: "계정설정", menuUrl: "/mngt/account" },
            // { menuTerm: "개발자전용", menuUrl: "/monitor/developer" },
            { menuTerm: "장비관리", menuUrl: "/mngt/device" }, 
          ]
        : userInfo.userTypeCode === 2003
        ? [
            // { menuTerm: "대시보드", menuUrl: "/dashboard"},
            // { menuTerm: "대시보드", menuUrl: "/monitor/dashboard" },
            { menuTerm: "전체현황", menuUrl: "/monitor/status/all" },
            // { menuTerm: "설치현황", menuUrl: "/monitor/status/install" },
            { menuTerm: "대상자정보", menuUrl: "/log/elder" },
            { menuTerm: "알림이력", menuUrl: "/log/alert" },
            { menuTerm: "담당자관리", menuUrl: "/mngt/manager" },
            { menuTerm: "대상자관리", menuUrl: "/mngt/elder" },
            // { menuTerm: '계정설정', menuUrl: '/mngt/account' },
          ]
        : [
            // { menuTerm: "대시보드", menuUrl: "/dashboard"},
            // { menuTerm: '대시보드', menuUrl: '/monitor/dashboard' },
            { menuTerm: "전체현황", menuUrl: "/monitor/status/all" },
            // { menuTerm: '설치현황', menuUrl: '/monitor/status/install' },
            { menuTerm: "대상자정보", menuUrl: "/log/elder" },
            { menuTerm: "알림이력", menuUrl: "/log/alert" },
            // { menuTerm: '담당자관리', menuUrl: '/mngt/manager' },
            { menuTerm: "대상자관리", menuUrl: "/mngt/elder" },
            { menuTerm: "계정설정", menuUrl: "/mngt/account" },
          ]
      : null;
    setMenuList(_menuList);
  }, [location.pathname]);

  useEffect(() => {
    // if(isDeveloper()) {
    //   document.getElementById("headerLogo").src = "/images/mobile/applogo_background.png";
    // } else {
    //   document.getElementById("headerLogo").src = "/images/area/" + getUser().rgnCode + "_logo.png";
    // }
  }, []);

  return (
    <>
      <header className="App-header" id="header_main">
        <div className="header_main_content">
          <nav className="uk-navbar">
            <div className="uk-float-left">
              <ul className="uk-navbar-nav user_actions headerHome">
                {/* <li>
                  <span className="gobackBtn" onClick={() => history.goBack()}>
                    <Reply style={{ fontSize: "35px", marginTop: "-6px", color: "#fff" }}></Reply>
                  </span>
                </li> */}
                <li>
                  <div className="Maindropdown">
                    <DropDownList
                      data={menuList}
                      textField="menuTerm"
                      dataItemKey="menuUrl"
                      value={currentHist}
                      onChange={menuChangeEvt}
                      className="menuDropDown"></DropDownList>
                  </div>
                </li>
              </ul>
            </div>
            <div className="uk-navbar-center">
              <h1 className="mainTitle">
                <span className="title" onClick={headerTextClickEvt}>
                  <img id="headerLogo" src="/images/mobile/applogo_background.png" alt="제이케이코어" />
                  안심박스 모니터링 서비스
                </span>
                {/* <img src="/images/headerText5.png" alt="제이케이코어" onClick={headerTextClickEvt} style={{ cursor: "pointer" }} /> */}
                {/* <img src="/images/title_fix_20211029.png" alt="제이케이코어" onClick={headerTextClickEvt} /> */}
                {/* <span className="mainTitleSpan" style={{ cursor: 'pointer' }} onClick={headerTextClickEvt}>
                  <img src="/images/title_fix_6.png" alt="제이케이코어" />
                  <span className="mainTitleText">비대면 통합돌봄 서비스</span>
                </span> */}
              </h1>
            </div>
            <div className="uk-navbar-flip">
              <ul className="uk-navbar-nav user_actions">
                <li className="user_action_icon headerTimer" style={{ pointerEvents: "none" }}>
                  <a href="#">
                    <HeaderTimer />
                  </a>
                </li>
                {/* <li><a href="#"  className="user_action_icon"><Notifications className="material-icons md-24 md-light"/><span className="uk-badge">5</span></a></li> */}
                {isLogin() ? (
                  <li>
                    <a href="#" onClick={logoutClickEvt} className="user_action_icon">
                      <span className="headimgB">
                        <img src="/images/icon_logout2.png" alt="로그아웃" />
                      </span>
                    </a>
                  </li>
                ) : (
                  <li>
                    <a href="#" onClick={loginClickEvt} className="user_action_icon">
                      <span className="headimgB">
                        <img src="/images/icon_login2.png" alt="로그인" />
                      </span>
                    </a>
                  </li>
                )}
                {/* <li>
                  <HeaderFullScr />
                </li> */}
              </ul>
            </div>
          </nav>
        </div>
      </header>
      <div id="cpr_footer">Copyright 2021 ⓒ JKCORE. All rights reserved.</div>
    </>
  );
}
export default Header;
